import React from 'react';
import { SectionInfo } from '../sectionInfo/sectionInfo'
import styles from './howItWorks.module.scss';

export const HowItWorks = () => {

  return (
    <section className={styles.howItWorks}>
      <SectionInfo top="Jak to działa?" bottom="Zaproś nas do domu" arrowLocation="right-right-bottom" textLocation='left' />
      <div className={styles.stepsContainer}>
        <div className={styles.stepWrap}>
            <img
              src="/images/krok-1-zdjecie.png"
              alt="krok 1"
            className={`${styles.wrapImage} ${styles.wrap1}`}
          />
          <div className={styles.step}>
            <h3>Krok 1</h3>
          <p>Wybierz dzień w kalendarzu i dodaj do koszyka nasze smakowite produkty.</p>

          <p>Sam decydujesz ile i z jakiej kategorii zamówisz.</p>


        </div>
        </div>

        <div className={styles.stepWrap}>
        <div className={styles.step}>
          <h3>Krok 2</h3>
          <p>Najpóźniej do 12:00 możesz złożyć zamówienie na następny dzień. Darmowa dostawa już od 69 zł.</p>
        </div>
</div>
        <div className={styles.stepWrap}>
        <div className={styles.step}>
                    <img
            src="/images/krok-2-3-zdjecie.png"
            alt="krok 2"
            className={`${styles.wrapImage} ${styles.wrap2}`}
          />
          <h3>Krok 3</h3>

          <p>Możesz złożyć zamówienie na dzień, kilka dni lub 2 tygodnie. Ty decydujesz!</p>
          <p>Z codzienną dostawą pod Twoje drzwi.</p>
        </div>
</div>
      </div>
    </section>
  )
}
